import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-item-produto-listar',
  templateUrl: './item-produto-listar.component.html',
  styleUrls: ['./item-produto-listar.component.scss']
})
export class ItemProdutoListarComponent extends AdmihairBaseComponent implements OnInit {

  loadingTable: boolean = true;
  itensProdutos: ItemProduto[] = [];
  situacoesStatus: SelectItem[] = [
    { label: 'ATIVOS', value: true },
    { label: 'INATIVOS', value: false }
  ];
  statusSelecionado: boolean = true;
  itensPaginados?: Paginador<ItemProduto>;
  numeroPagina = 0;
  inputBusca?: string = '';
  @ViewChild('filter') filter!: ElementRef;

  constructor(private itemProdutoService: ItemProdutoService,
    private confirmationService: ConfirmationService,
    utilStorageService: UtilStorageService,
    erroServiceComponent: ErroService,
    router: Router,
    activatedRoute: ActivatedRoute) {
    super(erroServiceComponent, utilStorageService, router, activatedRoute);
  }


  ngOnInit(): void {
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.carregarItensProdutos(this.numeroPagina);
    }
  }

  carregarItensProdutos(numPagina?: number) {
    this.itemProdutoService
      .listarPorEmpresaIdEStatusPaginado(this.getEmpresa()?.id, this.statusSelecionado,
       numPagina, this.inputBusca)
       .subscribe({
        next: (data: Paginador<ItemProduto>) => {
          this.itensPaginados = data;
          this.itensProdutos = data.content;
          this.loadingTable = false;
        },
        error: (err: any) => {
          this.loadingTable = false;
          this.exibirMensagemErro(err);
          
        }
      })
  }

  onPageChange(event: any) {
    this.loadingTable = true;
    if (this.itensPaginados) {
      this.numeroPagina = (event.first + event.rows) / this.itensPaginados.size;
    }
    this.carregarItensProdutos(this.numeroPagina - 1);
  }

  excluirItemProduto(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.itemProdutoService.excluir(id).subscribe({
          next: () => {
            this.carregarItensProdutos(0);
            this.exibirMensagemSucesso();
          },
          error: (error: any) => {
            this.exibirMensagemErro(error);
          }
        });
      }
    });
  }

  buscar(event: Event) {
    this.loadingTable = true;
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.carregarItensProdutos(0);
  }

  limpar() {
    this.loadingTable = true;
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.carregarItensProdutos(0);
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_PRODUTO');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PRODUTO');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PRODUTO');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PRODUTO');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_PRODUTO');
  }
  
}
